/**
 * Status color map – keyed by the lowercase status values
 * returned from the task/project status enums.
 */
export const STATUS_COLORS: Record<string, { border: string; bg: string }> = {
  todo: { border: 'border-navigation-accent-4', bg: 'bg-[#939393]' },
  active: { border: 'border-[#AD98FE]', bg: 'bg-[#AD98FE]' },
  inreview: { border: 'border-[#DB8734]', bg: 'bg-[#DB8734]' },
  paused: { border: 'border-[#962B81]', bg: 'bg-[#962B81]' },
  blocked: { border: 'border-[#D65757]', bg: 'bg-[#D65757]' },
  completed: { border: 'border-[#40B18F]', bg: 'bg-[#40B18F]' },
};

export const DEFAULT_COLOR = { border: 'border-[#939393]', bg: 'bg-[#939393]' };
export const normalizeStatus = (value?: string) =>
  (value || '').toLowerCase().replace(/[\s_-]/g, '');

interface StatusPointerProps {
  status?: string;
  size?: number;
}

export default function StatusPointer({
  status = 'completed',
  size = 20,
}: StatusPointerProps) {
  const normalized = normalizeStatus(status);
  const colors = STATUS_COLORS[normalized] || DEFAULT_COLOR;

  return (
    <div
      style={{ width: size, height: size, padding: size * 0.2 }}
      className={`flex items-center justify-center gap-2 rounded-full border ${colors.border}`}
    >
      <div
        style={{ width: size / 2, height: size / 2 }}
        className={`rounded-full ${colors.bg}`}
      />
    </div>
  );
}
